import { ButtonHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import { Container } from '../Container'
import { LangSwitcher } from '../LangSwitcher/LangSwitcher'
import cls from './StickyHeader.module.scss'

interface StickyHeaderProps {
    onPrimaryCtaClick: () => void
}

export const StickyHeader = ({ onPrimaryCtaClick }: StickyHeaderProps) => {
    const { t } = useTranslation()

    const ctaProps: ButtonHTMLAttributes<HTMLButtonElement> = {
        type: 'button',
        className: cls.cta,
        onClick: onPrimaryCtaClick
    }

    return (
        <header className={cls.root}>
            <Container className={cls.inner}>
                <div className={cls.brand}>
                    VANLIFE<span className={cls.brandDot} />
                </div>
                <div className={cls.right}>
                    <LangSwitcher />
                    <button {...ctaProps}>{t('hero.button')}</button>
                </div>
            </Container>
        </header>
    )
}
